import { getEndCursor } from 'components/Blocks/Pagination/paginationHelpers';
import { ReviewConnectionFragmentApi, useReviewQueryApi } from 'graphql/generated';
import { useQueryError } from 'hooks/graphQl/UseQueryError';
import { isReviewSource, ReviewConnectionType, REVIEWS_DEFAULT_PAGE_SIZE, ReviewType } from 'types/review';

export const useReviews = (
    page: number,
    productUuid: string,
    pageSize: number = REVIEWS_DEFAULT_PAGE_SIZE,
): ReviewConnectionType => {
    const [{ data, error }] = useReviewQueryApi({
        variables: {
            productUuid: productUuid,
            after: getEndCursor(page, 0, pageSize),
            first: pageSize,
        },
    });

    useQueryError(error);

    return {
        totalCount: data?.reviews.totalCount ?? 0,
        reviews: mapReviews(data?.reviews),
    };
};

const mapReviews = (data: ReviewConnectionFragmentApi | undefined): ReviewType[] => {
    const reviews: ReviewType[] = [];

    (data?.edges ?? []).forEach((itemEdge) => {
        if (itemEdge && itemEdge.node && isReviewSource(itemEdge.node.reviewSource)) {
            reviews.push({
                ...itemEdge.node,
                createdAt: new Date(itemEdge.node.createdAt),
                reviewSource: itemEdge.node.reviewSource,
                pros: itemEdge.node.pros ?? [],
                cons: itemEdge.node.cons ?? [],
                author: itemEdge.node.author,
                authorOrCustomerNameAnonymized: itemEdge.node.authorOrCustomerNameAnonymized,
            });
        }
    });

    return reviews;
};
